import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { resetContactUsFocus, updateUITabViewInfo } from '../../app/appActions';
import { shouldResetFocusSelector, isAgaveSelector, isAmcSelector, isGetHelpSelector, isNonAgaveSelector, isTeamsSelector, isThirdPartySelector, sourceAppSelector, shouldInitializeOcvSelector, isFeedbackTicketCreationEnabledSelector, isVLastInitializedSelector, isFeedbackCoachmarkEnabledSelector, getAimIdSelector, shouldSendAimIdSelector } from '../../app/selectors/contactUsSelector';
import { dispatchBypassThemeRouting, dispatchGetAlchemyThemeRoutingData, dispatchGetRegionInfo, dispatchShowCoachmark, dispatchUserInfoFetch } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { regionInfoSelector } from '../reduxUpdater/selectors/sharedStateSelectors';
import { getContactUsStyles } from '../styles/contactUsStyles';
import { OcvComponent } from '../presentationalComponents/OcvComponent';
import { setIsInitializedOcv } from '../reduxUpdater/actions/ocvActions';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    globalState: state.GlobalState,
    appName: state.GlobalState.sourceApp || state.GlobalState.appVer,
    sourceApp: sourceAppSelector(state),
    isThirdParty: isThirdPartySelector(state),
    isAgave: isAgaveSelector(state),
    isNonAgave: isNonAgaveSelector(state),
    isTeams: isTeamsSelector(state),
    regionInfo: regionInfoSelector(state),
    isAmc: isAmcSelector(state),
    isGetHelp: isGetHelpSelector(state),
    shouldResetFocus: shouldResetFocusSelector(state),
    ocvState: state.ContactState.OcvState,
    userInfo: state.ContactState.ModalitySectionState.userInfo,
    shouldInitializeOcv: shouldInitializeOcvSelector(state),
    market: state.GlobalState.market,
    isFeedbackCoachmarkEnabled: isFeedbackCoachmarkEnabledSelector(state),
    isFeedbackTicketCreationEnabled: isFeedbackTicketCreationEnabledSelector(state),
    IsOcvVNextEnabled: state.ContactState.OcvState.IsOcvVNextEnabled,
    isOcvInitialized: isVLastInitializedSelector(state),
    shouldSendAimId: shouldSendAimIdSelector(state),
    aimId: getAimIdSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchUserInfoFetch,
  dispatchGetRegionInfo,
  dispatchShowCoachmark,
  dispatchGetAlchemyThemeRoutingData,
  dispatchBypassThemeRouting,
  resetContactUsFocus,
  updateUITabViewInfo,
  setIsInitializedOcv,
};

export const OcvComponentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(OcvComponent, getContactUsStyles));
